<div class="dialog dialog--short">
  <app-base-header headerTitle="Claim Submitted" (closeClick)="close()"></app-base-header>
  <div class="dialog__content">
    <p>Thanks for submitting your claim. Your claim number is <strong>{{data.data.claim.claimNumber}}</strong>. It may take a few minutes before it shows up in the portal.</p>
  </div>
</div>

